import React from 'react';
import Logos from './Logos';
import styles from './Header.css';
import CheckMarkSvg from '../assets/CheckMarkSvg';

/* Below header banner alert if needed https://github.com/VetsFirstChoice/vfc-fast-fill/pull/124 */

const Header = () => ({
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <Logos />
        </div>
        <CheckMarkSvg />
      </div>
    );
  },
});

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx